
import { Capacitor } from '@capacitor/core';
import { mapGetters, mapActions, mapMutations } from 'vuex';

export default {
    data: () => ({
        showFloatingMenu: false,
        updaterInterval: null,
        lastSeen: null,
        timer: null,
        restaurantsNew: [],
        lastFetched: new Date().getMinutes(),
        loading: true,
    }),
    props: {
        searchText: { type: String, required: false },
        category: { type: Object, required: false },
        foodCategory: { type: Array, required: false },
        concept: { type: String, required: false },
    },
    methods: {
        ...mapActions('location', ['getLocation', 'initLocationInterval']),
        ...mapGetters('location', ['location', 'locationLoading', 'locationAllowed', 'locationLastSaved']),
        ...mapGetters('order', ['address', 'isDelivery', 'deliveryMethod', 'homeRoute']),
        ...mapMutations('ghostState', ['updateState']),
        ...mapMutations('order', ['setDeliveryMethod', 'setHomeRoute', 'isDelivery', 'lastLocation']),
        ...mapMutations('restaurants', ['setRestaurants']),
        async fetchData() {
            try {
                let deliveryMethodFilter = 'pickup-self-deliverit-tribe-mover';
                let options = {
                    params: {
                        include: 'locations,categories',
                        'filter[by_delivery_method]': deliveryMethodFilter,
                    },
                };
                if (this.concept) {
                    let key = 'filter[by_concept]';
                    options.params[key] = this.concept;
                }

                const location = this.$store.state.location.location;
                const lastSavedLocation = this.$store.state.order.lastLocation;
                const address = this.$store.state.order.address;

                if (this.isDelivery && location) {
                    options.params.lat = location.latitude;
                    options.params.lng = location.longitude;
                } else if (this.isDelivery && lastSavedLocation) {
                    options.params.lat = lastSavedLocation.lat;
                    options.params.lng = lastSavedLocation.lng;
                } else if (this.isDelivery && address) {
                    options.params.lat = address.lat;
                    options.params.lng = address.lng;
                }

                const response = await this.$axios.get('/restaurants', options);
                let resArr = response.data;

                //Filtering
                if (this.isDelivery) {
                    resArr = resArr.filter(x => x.inside_radius);
                }
                if (!this.isDelivery && (location || lastSavedLocation)) {
                    resArr = resArr.filter(x => x.locations.filter(y => y.pickup_option));
                    resArr = resArr.sort((a, b) => (a.distance > b.distance ? 1 : b.distance > a.distance ? -1 : 0));
                }

                // sorting
                if (resArr) {
                    resArr.forEach(restaurant => {
                        let sorting = 0;
                        if (restaurant.launching_soon) {
                            sorting -= 3;
                        } else {
                            sorting++;
                        }
                        if (restaurant.kitchen_is_open) {
                            sorting++;
                        }
                        if (restaurant.temp_closed) {
                            sorting -= 2;
                        }
                        if (!restaurant.launching_soon && !restaurant.temp_closed && restaurant.locations.length) {
                            if (restaurant.locations.filter(x => x.preorder_enabled).length) {
                                sorting++;
                            } else {
                                sorting--;
                            }
                        }
                        restaurant.sorting = sorting;
                    });
                }

                resArr.sort((a, b) => b.sorting - a.sorting);
                this.restaurantsNew = resArr;

                this.loading = false;
            } catch (error) {
                console.log(error);
            }
        },
        clientFetch() {
            try {
                this.getLocation(false);
                // this.getRestaurants(this.concept);
            } catch (error) {
                console.log({ error });
                if (this.$bugsnag) {
                    this.$bugsnag.notify(new Error(error));
                }
            }
        },
        hideFloatingMenu() {
            this.showFloatingMenu = false;
        },
        async promptLocation() {
            await this.getLocation();
        },
        filterRestaurantsBySearch(restaurants, searchText) {
            if (!searchText) return restaurants;
            
            return restaurants.filter(restaurant => 
                this.matchesSearchCriteria(restaurant, searchText)
            );
        },
        
        matchesSearchCriteria(restaurant, searchText) {
            return restaurant.categories.some(c => c.slug.includes(searchText)) ||
                   restaurant.description.toLowerCase().includes(searchText) ||
                   restaurant.name.toLowerCase().includes(searchText);
        }
    },

    async fetch() {
        await this.fetchData();
    },
    fetchOnServer: false,
    computed: {
        ...mapGetters('restaurants', ['restaurants', 'currentCategory', 'restaurantsLoading']),
        ...mapGetters('ghostState', ['allPagesLoaded']),
        ...mapGetters(['transition']),
        searchFilteredRestaurants() {
            return this.filterRestaurantsBySearch(
                this.restaurantsNew,
                this.searchText?.toLowerCase()
            );
        },
        searchParams() {
            return {
                location: this.location,
                address: this.address,
                deliveryMethod: this.deliveryMethod,
            };
        },
        isNative() {
            return Capacitor.isNative;
        },
        headline() {
            return 'København';
        },
        states() {
            return Object.is(this.$fetchState, undefined) ? true : this.$fetchState.pending;
        },
        isLocationAllowed() {
            return !(this.locationAllowed !== null && !this.locationAllowed);
        },
        noRestaurantsCanDeliver() {
            if (this.restaurants) {
                return this.restaurants.find(x => x.locations.find(y => y.delivery_option && !y.delivery_option.closed))
                    ? false
                    : true;
            }
            return false;

            /* if (this.restaurantLocation.hasOwnProperty('delivery_option')) {
                    if (this.restaurantLocation.delivery_option.type === 'deliverit') {
                        if (this.restaurantLocation.delivery_option.closed) {
                            return true;
                        }
                    }
                } */
        },
    },
    watch: {
        searchParams: {
            handler() {
                this.$fetch();
            },
            deep: true,
        },
        states: function (val) {
            this.updateState({ page: 'restaurant', pending: val });
        },
        isLocationAllowed(val) {
            this.updateState({ page: 'restaurant', pending: val });
        },
        deliveryMethod(newVal, oldVal) {
            if (oldVal !== 'pickup' && newVal === 'pickup') {
                this.getLocation();
            }
        },

       //User changes address through AddressCheckModal
        '$store.state.order.address': {
            handler() {
                this.$fetch();
            },
            deep: true
        }
    },
    activated() {
        //this.fetchData();
        setTimeout(() => {
            this.showFloatingMenu = true;
        }, 300);
    },
    mounted() {
        this.setHomeRoute('/');
        setTimeout(() => {
            this.showFloatingMenu = true;
        }, 300);
        if (!this.isDelivery || (this.isDelivery && !this.address)) {
            this.getLocation();
        }
        this.lastSeen = new Date();
        this.updaterInterval = setInterval(() => {
            if (new Date() - this.lastSeen > 1000 * 60) {
                setTimeout(() => {
                    this.$fetch();
                }, 2000);
            }
            this.lastSeen = new Date();
        }, 1000 * 59);

        //Timeout to sync minutes
        setTimeout(() => {
            if (new Date().getMinutes() % 30 === 0) {
                this.fetchData();
            }
            this.timer = setInterval(() => {
                let now = new Date().getMinutes();
                if (now % 30 === 0 && now !== this.lastFetched) {
                    this.fetchData();
                }
                this.lastFetched = now;
            }, 60 * 1000);
        }, Math.abs(new Date().getSeconds() - 60) * 1000 + 1000);
        this.$nextTick();
    },
    beforeDestroy() {
        try {
            clearInterval(this.updaterInterval);
        } catch (e) {
            //Do nothing
        }
    },
    beforeDestroy() {
        if (this.timer) {
            clearInterval(this.timer);
        }
    },
};
